interface IAnamnesisFormControl {
    key: AnamnesisField;
    label: string;
}

enum AnamnesisField {
    ademstops = 'ademstops',
    concentratieverlies = 'concentratieverlies',
    ervaring_te_stikken_tijdens_slaap = 'ervaring_te_stikken_tijdens_slaap',
    geheugenproblemen = 'geheugenproblemen',
    herhaald_wakker_schrikken = 'herhaald_wakker_schrikken',
    humeur_kort_lontje_depressieve_gevoelens = 'humeur_kort_lontje_depressieve_gevoelens',
    niet_verfrissende_slaap = 'niet_verfrissende_slaap',
    overmatige_slaperigheid_overdag = 'overmatige_slaperigheid_overdag',
    snurken = 'snurken',
    stokkende_ademhaling = 'stokkende_ademhaling',
    vermoeidheid_overdag = 'vermoeidheid_overdag',
}

export const anamnesisFieldsNsi: IAnamnesisFormControl[] = [
    { key: AnamnesisField.overmatige_slaperigheid_overdag, label: 'Overmatige slaperigheid overdag' },
    { key: AnamnesisField.stokkende_ademhaling, label: 'Stokkende ademhaling' },
    { key: AnamnesisField.herhaald_wakker_schrikken, label: 'Herhaald wakker schrikken' },
    { key: AnamnesisField.niet_verfrissende_slaap, label: 'Niet verfrissende slaap' },
    { key: AnamnesisField.vermoeidheid_overdag, label: 'Vermoeidheid overdag' },
    { key: AnamnesisField.concentratieverlies, label: 'Concentratieverlies' },
    { key: AnamnesisField.snurken, label: 'Snurken' },
    { key: AnamnesisField.ademstops, label: 'Ademstops' },
    {
        key: AnamnesisField.humeur_kort_lontje_depressieve_gevoelens,
        label: 'Humeur, kort lontje, depressieve gevoelens',
    },
    { key: AnamnesisField.geheugenproblemen, label: 'Geheugenproblemen' },
];

export const anamnesisFieldsKsyosSleep: IAnamnesisFormControl[] = [
    { key: AnamnesisField.snurken, label: 'Snurken' },
    { key: AnamnesisField.ademstops, label: 'Ademstops opgemerkt tijdens slaap' },
    { key: AnamnesisField.ervaring_te_stikken_tijdens_slaap, label: 'Ervaring te stikken tijdens slaap' },
    { key: AnamnesisField.niet_verfrissende_slaap, label: 'Niet verfrissende slaap' },
    { key: AnamnesisField.overmatige_slaperigheid_overdag, label: 'Slaperigheid overdag' },
    { key: AnamnesisField.vermoeidheid_overdag, label: 'Vermoeidheid overdag' },
    {
        key: AnamnesisField.concentratieverlies,
        label: 'Concentratieverlies, geheugenproblemen, humeurig, of neerslachtig',
    },
];
